import React, { useEffect, useState } from "react";
import "primeicons/primeicons.css";
import { Button } from "primereact/button";
import api from "../../utils/api.js";
import cogoToast from "cogo-toast";
import APIConstant from "../../utils/constant.js";
import Loader from "components/Shared/Loader/Loader";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const POSBillConfiguration = () => {
  const [securityUserID, setSecurityUserID] = useState(null);

  const [configId, setConfigId] = useState("");
  const headerHtml = `
    <h2>Terms & Conditions</h2>

                    <p>1. The Company is not responsible for any leakage, shortage, or breakage caused by rain, fire, weather, or any other external factors. The sender is responsible for ensuring proper packing of goods.</p>
                    <p>2. Fresh fruits are carried at the sole risk of the consignor, as they are pkely to spoil during transit.</p>

                    <p>3. The Company will dispatch goods at the earpest opportunity, either in one shipment or in part, depending on its convenience.</p>

                    <p>4. Goods will be depvered to the consignee or their agent only upon payment of all charges.</p>

                    <p>5. Goods will be depvered to the Company's warehouse at the destination unless otherwise agreed upon in writing.</p>

                    <p>6. The goods must be collected within three days of arrival at the destination.</p>

                    <p>7. Any claims regarding the goods must be made within 15 days of receipt; otherwise, the claim will be considered invapd.</p>

                    <p>8. The Company is not pable for delays or losses due to accidents, strikes, weather conditions, breakdowns, or other circumstances beyond its control.</p>

                    <p>9. Once depvery is made against a receipt, no further claims will be entertained.</p>

                    <p>10. If goods are incorrectly assessed by Octroi or Customs authorities, the Company will not be held responsible. Any claims should be made directly by the consignor or sender to the relevant authorities.
                    </p>
                    <p>11. If there is a discrepancy between the actual weight and the weight recorded on the Goods Receipt (GR), the Company will charge for the actual weight at the destination, plus an additional 2% charge.</p>

                    <p>12. If goods do not arrive at the destination within one month, the consignor must notify the Company in writing via registered notice. Failure to do so will repeve the Company of any responsibipty for the goods.</p>

                    <p>13. If the consignee does not collect the goods within three months, the Company reserves the right to auction the goods. The consignor will be responsible for any outstanding charges after deducting the sale proceeds.</p>

                    <p>14. If the consignor wishes to insure the goods against fire or damage during transit, this must be declared, and the consignor must pay the quoted premium.</p>

                    <p>15. Any disputes regarding this consignment will be subject to the jurisdiction of Gandhidham. If the dispute is not resolved through initial negotiations, it will be settled through arbitration under the Indian Arbitration Act.</p>

                    <p>16. In case the truck cannot reach the destination in rural or inaccessible areas, the consignee must take depvery of the goods at the nearest accessible point, paying the full freight charges to the driver.</p>

                    <p>17. For consignments valued above Rs. 100, the goods must be insured. The Company will not be responsible for any loss or damage if insurance is not provided.</p>
        `;
  const [content, setContent] = useState("");
  useEffect(() => {
    const data = localStorage.getItem("Infodata");
    setSecurityUserID(data);
    GetPOSBillConfiguration(data);
    return () => {};
  }, []);

  const GetPOSBillConfiguration = async (UserId) => {
    try {
      let paramData = {
        UserId: UserId,
      };
      await api
        .post(APIConstant.path.GetPOSBillConfiguration, paramData)
        .then(async (response) => {
          let resp = await response;
          if (resp.Success === 1) {
            setConfigId(response.Data._id);
            setContent(response.Data.Content);
          }
        });
    } catch (error) {
      console.log("err", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let paramData = {
      UserId: securityUserID,
      Content: content.replace(/'/g, "`"),
      ConfigId: configId,
    };

    await api
      .post(APIConstant.path.AddUpdatePOSBillConfiguration, paramData)
      .then(async (res) => {
        const response = await res;
        if (response.success) {
          cogoToast.success(response.message);
          Loader.hide();
          GetPOSBillConfiguration(securityUserID);
        } else {
          cogoToast.error(response.message);
          Loader.hide();
        }
      })
      .catch((err) => {
        cogoToast.error(err);
        Loader.hide();
      });
  };

  const handledocument = (e) => {
    setContent(e);
  };

  return (
    <div className="wayment-owner-dashboard e-weighment-dashoard">
      <div className="heading-area p-d-flex p-ai-center p-jc-between p-pr-2 p-pl-3">
        <div className="p-d-flex p-ai-center">
          <i className="pi pi-images"></i>
          <h2>POS Bill configuration</h2>
        </div>
      </div>
      <hr />

      <div className="load-main">
        <div>
          <h3 className="p-m-0">Header</h3>
          <ReactQuill
            theme="snow"
            value={content}
            onChange={(e) => handledocument(e)}
            style={{ height: "260px" }}
          />
        </div>
        <div className="p-d-flex p-jc-end p-mt-6">
          <Button
            type="button"
            className="primary-btn p-button p-component p-jc-center p-ml-2"
            onClick={(e) => handleSubmit(e)}
          >
            SUBMIT
          </Button>
        </div>
      </div>
    </div>
  );
};

export default POSBillConfiguration;
